export default {
  leastDrawn: 'Eng kam tushganlari',
  mostDrawn: 'Eng ko‘p tushganlari',
  leastPlayed: 'Eng kam o‘ynalganlari',
  mostPlayed: 'Eng ko‘p o‘ynalganlari',
  drawFrom: 'Chiqish vaqti',
  h: 'soat',
  startingIn: 'Boshlanishigacha',
  waitingForDrawnFrom: 'Chiqishini kutmoqda',
  displayingDrawFrom: 'Chiqish vaqti ko‘rsatilmoqda',
  lotteryDraw: 'Lotereya tiraji',
  eventId: 'Hodisa IDsi',
  bettingShortcuts: 'Stavkalar uchun qisqartmalar',
  draw: 'Tiraj',
  next5Events: 'Keyingi {value} ko‘rsatilmoqda',
  events: 'Hodisalar',
  schedule: 'Jadval',
  next: 'Keyingi',
  event: 'Hodisa',
  later: 'Keyinroq',
  statistics: 'Statistika',
  lastnRounds: 'Oxirgi {value} ta raund',
  bettingOffer: 'Stavkalar uchun taklif',
  notDisplayed: 'Ko‘rsatilmayapti',
  latestResults: 'Oxirgi natijalar',
  drawnAt: '{value} da tushdi',
  additionalBetting: 'Qo‘shimcha stavkalar',
  drawSumEvenOdd: 'Tiraj yig‘indisi',
  drawSumTotal: 'Chiqish yig‘indisi jami',
  drawSumRange: 'Tiraj yig‘indisi diapazoni',
  waitingForDrawNo: '№{value}-tiraj kutilmoqda',
  nextDraw: 'Keyingi tiraj',
  waitingForDraw: 'Tiraj kutilmoqda',
  drawCompleted: 'Tiraj yakunlandi',
  drawDisplayTemporarilyNotAvailable: 'Tirajni ko‘rsatish vaqtincha mavjud emas',
  connectionError: 'Ulanish xatosi!',
  reconnecting: 'Qayta ulanish...',
  number: 'Raqam',
  headerNumberDescriptionUp: 'Hodisa',
  headerNumberDescriptionDown: 'Raqam',
};
